'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function MKFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-iouqaxwyq", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-qa09brj4d", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-n7wgo4d5k" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-n7wgo4d5k", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-iouqaxwyq)" }, /* @__PURE__ */ React.createElement("use", { fill: "#f50100", xlinkHref: "#mantine-n7wgo4d5k" }), /* @__PURE__ */ React.createElement("g", { fill: "#ffd018" }, /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M18 14.024l14 5.952v4.084h-3.255zM14 14L3.255 24.035H0v-4.084zm2-2l3 12h-6zm16-3v6l-12-3zM0 9l12 3-12 3zm19-9l-3 12-3-12zm13-.018v4.084l-14 5.952L28.745-.018zM3.255-.042L14 9.993 0 4.042V-.042z",
        mask: "url(#mantine-qa09brj4d)"
      }
    ), /* @__PURE__ */ React.createElement(
      "circle",
      {
        cx: "16",
        cy: "12",
        r: "5",
        stroke: "#f50100",
        strokeWidth: "2",
        mask: "url(#mantine-qa09brj4d)"
      }
    ))))
  );
}

export { MKFlag };
//# sourceMappingURL=MK.mjs.map
